export const app = {
    title: 'Form Generateur',
    modals:{
        session:{
            title:'Souhaitez vous conserver les données de votre session précédente',
            confirm:'Oui',
            cancel:'Non',
        },
        error:{
            title:'Une erreur est survenue, veuillez réessayer',
            confirm:'Réessayer',
        }
    }
}
